import { createFileRoute } from '@tanstack/react-router';

import { ShipmentCardPage } from '../../features/shipment-card';

// Подчёркивание в имени файла выводит карточку из-под списка: путь
// /shipments/$shipmentId, но без вложения в экран «Отгрузки в работе».
export const Route = createFileRoute('/_app/shipments_/$shipmentId')({
  staticData: { crumbs: ['Отгрузки', 'Карточка отгрузки'] },
  component: ShipmentCardPage,
});
